import { render } from "./BroadcastComposerModal.vue?vue&type=template&id=7f2afe2a"
import script from "./BroadcastComposerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastComposerModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/BroadcastComposerModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f2afe2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f2afe2a', __exports__)) {
    api.reload('7f2afe2a', __exports__)
  }
  
  module.hot.accept("./BroadcastComposerModal.vue?vue&type=template&id=7f2afe2a", () => {
    api.rerender('7f2afe2a', render)
  })

}


export default __exports__